// This file is auto-generated by @hey-api/openapi-ts

import { queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { deleteApiFolderPermissionsByGraphFolderIdRemove, getApiDirectoryUsers, getApiFolderPermissionsByGraphFolderId, getApiLicensingCheck, getApiLicensingCurrent, getApiLicensingVersion, getApiMailFolders, type Options, postApiFolderPermissionsApplyAll, postApiFolderPermissionsApplySelected, postApiFolderPermissionsByGraphFolderIdAdd, putApiFolderPermissionsByGraphFolderIdUpdate } from '../sdk.gen';
import type { DeleteApiFolderPermissionsByGraphFolderIdRemoveData, DeleteApiFolderPermissionsByGraphFolderIdRemoveError, DeleteApiFolderPermissionsByGraphFolderIdRemoveResponse, GetApiDirectoryUsersData, GetApiDirectoryUsersError, GetApiDirectoryUsersResponse, GetApiFolderPermissionsByGraphFolderIdData, GetApiFolderPermissionsByGraphFolderIdError, GetApiFolderPermissionsByGraphFolderIdResponse, GetApiLicensingCheckData, GetApiLicensingCheckError, GetApiLicensingCheckResponse, GetApiLicensingCurrentData, GetApiLicensingCurrentError, GetApiLicensingCurrentResponse, GetApiLicensingVersionData, GetApiLicensingVersionError, GetApiLicensingVersionResponse, GetApiMailFoldersData, GetApiMailFoldersError, GetApiMailFoldersResponse, PostApiFolderPermissionsApplyAllData, PostApiFolderPermissionsApplyAllError, PostApiFolderPermissionsApplyAllResponse, PostApiFolderPermissionsApplySelectedData, PostApiFolderPermissionsApplySelectedError, PostApiFolderPermissionsApplySelectedResponse, PostApiFolderPermissionsByGraphFolderIdAddData, PostApiFolderPermissionsByGraphFolderIdAddError, PostApiFolderPermissionsByGraphFolderIdAddResponse, PutApiFolderPermissionsByGraphFolderIdUpdateData, PutApiFolderPermissionsByGraphFolderIdUpdateError, PutApiFolderPermissionsByGraphFolderIdUpdateResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getApiDirectoryUsersQueryKey = (options?: Options<GetApiDirectoryUsersData>) => createQueryKey('getApiDirectoryUsers', options);

export const getApiDirectoryUsersOptions = (options?: Options<GetApiDirectoryUsersData>) => queryOptions<GetApiDirectoryUsersResponse, GetApiDirectoryUsersError, GetApiDirectoryUsersResponse, ReturnType<typeof getApiDirectoryUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiDirectoryUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiDirectoryUsersQueryKey(options)
});

export const getApiFolderPermissionsByGraphFolderIdQueryKey = (options: Options<GetApiFolderPermissionsByGraphFolderIdData>) => createQueryKey('getApiFolderPermissionsByGraphFolderId', options);

export const getApiFolderPermissionsByGraphFolderIdOptions = (options: Options<GetApiFolderPermissionsByGraphFolderIdData>) => queryOptions<GetApiFolderPermissionsByGraphFolderIdResponse, GetApiFolderPermissionsByGraphFolderIdError, GetApiFolderPermissionsByGraphFolderIdResponse, ReturnType<typeof getApiFolderPermissionsByGraphFolderIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiFolderPermissionsByGraphFolderId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiFolderPermissionsByGraphFolderIdQueryKey(options)
});

export const postApiFolderPermissionsApplyAllMutation = (options?: Partial<Options<PostApiFolderPermissionsApplyAllData>>): UseMutationOptions<PostApiFolderPermissionsApplyAllResponse, PostApiFolderPermissionsApplyAllError, Options<PostApiFolderPermissionsApplyAllData>> => {
    const mutationOptions: UseMutationOptions<PostApiFolderPermissionsApplyAllResponse, PostApiFolderPermissionsApplyAllError, Options<PostApiFolderPermissionsApplyAllData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiFolderPermissionsApplyAll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiFolderPermissionsApplySelectedMutation = (options?: Partial<Options<PostApiFolderPermissionsApplySelectedData>>): UseMutationOptions<PostApiFolderPermissionsApplySelectedResponse, PostApiFolderPermissionsApplySelectedError, Options<PostApiFolderPermissionsApplySelectedData>> => {
    const mutationOptions: UseMutationOptions<PostApiFolderPermissionsApplySelectedResponse, PostApiFolderPermissionsApplySelectedError, Options<PostApiFolderPermissionsApplySelectedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiFolderPermissionsApplySelected({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiFolderPermissionsByGraphFolderIdAddMutation = (options?: Partial<Options<PostApiFolderPermissionsByGraphFolderIdAddData>>): UseMutationOptions<PostApiFolderPermissionsByGraphFolderIdAddResponse, PostApiFolderPermissionsByGraphFolderIdAddError, Options<PostApiFolderPermissionsByGraphFolderIdAddData>> => {
    const mutationOptions: UseMutationOptions<PostApiFolderPermissionsByGraphFolderIdAddResponse, PostApiFolderPermissionsByGraphFolderIdAddError, Options<PostApiFolderPermissionsByGraphFolderIdAddData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiFolderPermissionsByGraphFolderIdAdd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteApiFolderPermissionsByGraphFolderIdRemoveMutation = (options?: Partial<Options<DeleteApiFolderPermissionsByGraphFolderIdRemoveData>>): UseMutationOptions<DeleteApiFolderPermissionsByGraphFolderIdRemoveResponse, DeleteApiFolderPermissionsByGraphFolderIdRemoveError, Options<DeleteApiFolderPermissionsByGraphFolderIdRemoveData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiFolderPermissionsByGraphFolderIdRemoveResponse, DeleteApiFolderPermissionsByGraphFolderIdRemoveError, Options<DeleteApiFolderPermissionsByGraphFolderIdRemoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiFolderPermissionsByGraphFolderIdRemove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putApiFolderPermissionsByGraphFolderIdUpdateMutation = (options?: Partial<Options<PutApiFolderPermissionsByGraphFolderIdUpdateData>>): UseMutationOptions<PutApiFolderPermissionsByGraphFolderIdUpdateResponse, PutApiFolderPermissionsByGraphFolderIdUpdateError, Options<PutApiFolderPermissionsByGraphFolderIdUpdateData>> => {
    const mutationOptions: UseMutationOptions<PutApiFolderPermissionsByGraphFolderIdUpdateResponse, PutApiFolderPermissionsByGraphFolderIdUpdateError, Options<PutApiFolderPermissionsByGraphFolderIdUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiFolderPermissionsByGraphFolderIdUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiLicensingCheckQueryKey = (options?: Options<GetApiLicensingCheckData>) => createQueryKey('getApiLicensingCheck', options);

export const getApiLicensingCheckOptions = (options?: Options<GetApiLicensingCheckData>) => queryOptions<GetApiLicensingCheckResponse, GetApiLicensingCheckError, GetApiLicensingCheckResponse, ReturnType<typeof getApiLicensingCheckQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiLicensingCheck({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLicensingCheckQueryKey(options)
});

export const getApiLicensingCurrentQueryKey = (options?: Options<GetApiLicensingCurrentData>) => createQueryKey('getApiLicensingCurrent', options);

export const getApiLicensingCurrentOptions = (options?: Options<GetApiLicensingCurrentData>) => queryOptions<GetApiLicensingCurrentResponse, GetApiLicensingCurrentError, GetApiLicensingCurrentResponse, ReturnType<typeof getApiLicensingCurrentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiLicensingCurrent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLicensingCurrentQueryKey(options)
});

export const getApiLicensingVersionQueryKey = (options?: Options<GetApiLicensingVersionData>) => createQueryKey('getApiLicensingVersion', options);

export const getApiLicensingVersionOptions = (options?: Options<GetApiLicensingVersionData>) => queryOptions<GetApiLicensingVersionResponse, GetApiLicensingVersionError, GetApiLicensingVersionResponse, ReturnType<typeof getApiLicensingVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiLicensingVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLicensingVersionQueryKey(options)
});

export const getApiMailFoldersQueryKey = (options?: Options<GetApiMailFoldersData>) => createQueryKey('getApiMailFolders', options);

export const getApiMailFoldersOptions = (options?: Options<GetApiMailFoldersData>) => queryOptions<GetApiMailFoldersResponse, GetApiMailFoldersError, GetApiMailFoldersResponse, ReturnType<typeof getApiMailFoldersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiMailFolders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiMailFoldersQueryKey(options)
});
